import { RouteConfig } from 'vue-router';

import ResetPassword from '@/views/ResetPassword.vue';

export const resetPasswordRoute: RouteConfig = {
  path: '/reset',
  name: 'reset',
  component: ResetPassword
};
